import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, ESTIMATOR, SELLER } = authRoles

const Calendar = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const calendarModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar,
    meta: {
      title: 'Calendario',
      auth: {
        roles: [ADMIN, ESTIMATOR, SELLER],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
